const formValidation = {
  checkInputValidity: (input, customErrorMessage) => {
    const { validity } = input;
    const isValid = validity.valid;
    const providedMessage = input.getAttribute("title");
    if (isValid) {
      return void 0;
    }
    const isEmpty = validity.valueMissing;
    const isIncorrectType = validity.typeMismatch;
    const isIncorrectPattern = validity.patternMismatch;
    const isTooLong = validity.tooLong || validity.rangeOverflow;
    const isTooShort = validity.rangeUnderflow;
    const isInvalidStep = validity.stepMismatch;
    const possibleErrors = [
      { invalid: isEmpty, message: providedMessage || "A value is required." },
      {
        invalid: isIncorrectType,
        message: providedMessage || "Please verify that your input is the expected type (ie: email address)."
      },
      { invalid: isIncorrectPattern, message: providedMessage || "This input does not match the expected value." },
      { invalid: isTooLong, message: providedMessage || "Your input is too long." },
      { invalid: isTooShort, message: providedMessage || "Your input is too short." },
      { invalid: isInvalidStep, message: providedMessage || "Unexpected value." }
    ];
    const errorOutput = possibleErrors.find((error) => error.invalid);
    return customErrorMessage || (errorOutput == null ? void 0 : errorOutput.message);
  },
  isFormValid: (requiredFields, context) => !!requiredFields.find((field) => {
    var _a, _b;
    return !context[field] || !((_a = context[field]) == null ? void 0 : _a.value) || !!((_b = context[field]) == null ? void 0 : _b.error);
  })
};
export default formValidation;
